import { render, staticRenderFns } from "./hj.vue?vue&type=template&id=1ede3d74"
import script from "./hj.vue?vue&type=script&lang=js"
export * from "./hj.vue?vue&type=script&lang=js"
import style0 from "./hj.vue?vue&type=style&index=0&id=1ede3d74&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports